import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

// Type for the plan response
type PlanResponse = {
    data: {
        id: string;
        name: string;
        price: number;
        description: string;
        plans_interval: string;
        is_active: boolean;
        created_at: string;
    };
    meta?: any;
};

// API call to get a specific plan feature
export const getPlan = async (plan_id: string) => {
    const response = await Axios.get<PlanResponse>(`/plan/${plan_id}`);
    return response.data;
};

// React Query hook
export const useGetPlan = (plan_id: string) => {
    return useQuery({
        queryKey: ["get-plan", plan_id],
        queryFn: () => getPlan(plan_id),
        enabled: !!plan_id, // Only run if ID is provided
        retry: 1,
    });
};
